<template>
    <div v-if="toggle">
        <!-- <div class="top">
      <div class="w1200">
        <span id="date">百科博创为您提供科研导航，学术搜索聚合等功能，欢迎大家收藏本站！（按ctrl+D）将本站加入浏览器收藏夹！</span>
      </div>
    </div> -->
        <div class="white">
            <div class="head">
                <div class="logo">
                    <router-link to="/">
                        <img src="../assets/logo.png" alt="dotaindex" style="width: 150px;">
                    </router-link>
                </div>
                <div style="float: left; padding:9px 20px; text-align: center; font-size: 13px;">
                    <div style="float: left;">
                        {{ month }}月{{ date }}日 {{ day }} <br />{{ lunar }}
                    </div>
                    <!-- <div v-if="weatherData != null" style="float: left; margin-left: 10px;">
                        <i v-show="!weatherData.weather.includes('云') && !weatherData.weather.includes('阴') && !weatherData.weather.includes('雨')" class="qi-sunny"
                            style="color: #14aab9;"></i>
                        <i v-show="weatherData.weather.includes('云') || weatherData.weather.includes('阴')" class="qi-overcast" style="color: #14aab9;"></i>
                        <i v-show="weatherData.weather.includes('雨')" class="qi-moderate-rain" style="color: #14aab9;"></i>
                        &nbsp;{{ weatherData.city }}<br /> {{ weatherData.weather }}  &nbsp;&nbsp; {{ weatherData.temperature }}°C 
                    </div> -->
                </div>
                <AccountWiget></AccountWiget>
                <div style="float: right; margin-right: 15px; padding:9px 20px;    line-height: 18px;color:#14aab9; font-size: 14px;">
                    <!--            <el-switch-->
                    <!--                @change="changeMode"-->
                    <!--                v-model="mode"-->
                    <!--                size="small"-->
                    <!--                active-color="#14aab9"-->
                    <!--                inactive-color="#14aab93b"-->
                    <!--                style="margin-top: -2px;"-->
                    <!--            >-->
                    <!--            </el-switch>-->
                    <a @click="mode = !mode; changeMode(mode)" style="color: #14aab9;"><i class="fa fa-th" aria-hidden="true" style="margin-right: 5px"></i>{{ mode ? '详细' : '精简'
                        }}</a>
                    <!--            <el-popover>-->
                    <!--                <div style="line-height: 25px;">-->
                    <!--                <p><a @click="changeMode(false)">详细模式</a></p>-->
                    <!--                <p><a @click="changeMode(true)">精简模式</a></p>-->
                    <!--                </div>-->
                    <!--                <a slot="reference">-->
                    <!--                    <i class="el-icon-s-grid" style="font-size: 14px;color: #14aab9;"></i>-->
                    <!--                    &nbsp{{mode ? '精简' : '详细'}}模式-->
                    <!--                </a>-->
                    <!--            </el-popover>-->
                </div>
            </div>
        </div>
        <div class="nav">
            <ul>
                <!-- <li><a href="/">网站首页</a></li> -->
            </ul>
        </div>
    </div>
</template>


<script>
import axios from "axios";
import AccountWiget from "./AccountWiget";
import { getLunar } from 'chinese-lunar-calendar'
import pinyin from "js-pinyin";

export default {
    components: { AccountWiget },
    data() {
        let weekStr = '日一二三四五六'

        return {
            weatherData: null,
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            date: new Date().getDate(),
            day: '星期' + weekStr[new Date().getDay()],
            lunar: '',
            mode: false,
            toggle: true
        }
    },
    created() {
        //加载天气查询插件
        let self = this

        window.onLoad = function () {
            // AMap.plugin('AMap.Geolocation', function () {
            //     var citySearch = new AMap.Geolocation()
            //     citySearch.getCityInfo(function (status, result) {
            //         if (status === 'complete' && result.info === 'SUCCESS') {
            //             // 查询成功，result即为当前所在城市信息
            //             console.log({ result });
            //             axios.create({
            //                 baseURL: 'https://api.seniverse.com/v3/weather/',
            //                 timeout: 30000 // 请求超时时间
            //             })({
            //                 url: `now.json?key=SEN6gItEzrB0D3Bw_&location=${result.city}`,
            //                 method: 'get',
            //             }).then(res => {
            //                 const weatherinfo  = res.data.results[0]
            //                 const data = {
            //                     city: result.city,
            //                     weather: weatherinfo.now.text,
            //                     temperature: weatherinfo.now.temperature
            //                 }
            //                 self.weatherData = data
            //             })

            //         }
            //     })
            // })
        }

        window._AMapSecurityConfig = {
            // serviceHost:'https://sgp.dotaindex.com/_AMapService',
            securityJsCode: '4cbefec0af34d1d9541c7deb2018dda6'
            // 例如 ：serviceHost:'http://1.1.1.1:80/_AMapService',
        }
        var url = 'https://webapi.amap.com/maps?v=1.4.15&key=6264e5f87604630fab30a29f7d2493b4&callback=onLoad';
        var jsapi = document.createElement('script');
        jsapi.charset = 'utf-8';
        jsapi.src = url;
        // document.head.appendChild(jsapi);

        // { "lunarMonth": 2, "lunarDate": 3, "isLeap": false, "solarTerm": null, "lunarYear": "癸卯年", "zodiac": "兔", "dateStr": "二月初三" }
        let lunarData = getLunar(this.year, this.month, this.date)
        this.lunar = lunarData.lunarYear + ' ' + lunarData.dateStr
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'changeRoute'
    },
    methods: {
        changeMode(v) {
            this.mode = v
            console.log(this.mode)
            // this.global.simpleMode = this.mode
            if (v) {
                this.$router.push("/simple")
            } else {
                this.$router.push('/')
            }
        },
        changeRoute(e) {
            if (e.path == '/cytotry') {
                this.toggle = false
            } else {
                this.toggle = true
            }
            this.mode = e.path === '/simple'
        }
    }
}
</script>

<style scoped>
.user-menu {
    text-align-last: center;
}

.user-menu a {
    line-height: 30px;
}

.user-menu a:hover {
    color: #1cc3d5;
}

.top {
    width: 100%;
    height: 36px;
    background: #555555;
    line-height: 36px;
    font-size: 12px;
    color: #aaa;
    min-width: 1200px;
}

.w1200 {
    width: 1200px;
}

.w1200 a {
    color: #aaa;
}

.w1200 span em {
    margin: 0 8px
}

#date em {
    margin-left: 8px;
}

.head {
    /* width: 1200px; */
    padding: 0 10px;
    height: 94px;
    padding-top: 10px;
}

.logo {
    float: left;
}

.white {
    width: 100%;
    height: 94px;
    /* background: white;  */
    min-width: 1200px;
}


.account {
    float: right;
}

.account a {
    background: #14aab9;
    border-radius: 4px;
    color: #fff;
    padding: 0 10px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    display: inline-block;
    margin-left: 10px;
}

.nav {
    width: 100%;
    height: 0px;
    background: #14aab9;
}

.nav ul {
    width: 1200px;
}

.nav ul li {
    float: left;
    height: 45px;
    width: 133px;
    line-height: 45px;
    font-size: 16px;
    text-align: center;
    transition: all 0.3s;
}

.nav ul li a {
    color: #fff;
    display: block;
}

.nav ul li.on,
.nav ul li:hover {
    background: #c9380c;
}

.nav ul li.on a,
.nav ul li:hover a {
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue